import Model from '../Model/Model';
class Controller {
  constructor() {
    this.model = new Model();
  }
}

export default Controller;
